import React, { forwardRef } from "react";
import { Button, ButtonProps } from "@mui/material";
import { Link, LinkProps } from "react-router-dom";
import ReactGA from "react-ga";
import { buildDonatePath, BuildDonatePathProps } from "Utils/Checkout";
import { PlanAlertDialogProps } from "./PlanAlertDialog";
import "../../i18n/config";
import { useTranslation } from "react-i18next";

export type DonateButtonProps = ButtonProps &
  Partial<LinkProps> & {
    queryParams?: BuildDonatePathProps;
    isFreeTrial?: boolean;
    alertDialog?: PlanAlertDialogProps;
  };

const DonateButton = forwardRef<any, DonateButtonProps>((props, ref) => {
  const {
    children,
    queryParams,
    alertDialog,
    isFreeTrial = false,
    ...rest
  } = props;

  const { t } = useTranslation();

  const openAlertDialog = () => {
    if (!alertDialog) return;

    ReactGA.event({
      category: "button",
      action: "expiring",
      days: alertDialog.subscription?.termEnd.daysUntil,
    } as any);

    alertDialog.setOpen(true);
  };

  return alertDialog?.subscription ? (
    <Button ref={ref} color="primary" onClick={openAlertDialog} {...rest}>
      {children || "Renew my plan"}
    </Button>
  ) : (
    <Button
      ref={ref}
      color="primary"
      component={Link}
      to={buildDonatePath(queryParams)}
      target={buildDonatePath(queryParams)}
      {...rest}
    >
      {children || (isFreeTrial ? t("freeTrial.donate") : t("donationPage.title"))}
    </Button>
  );
});

export default DonateButton;
